// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorAlgolia = (client) => ({
    /**
     * `POST /vendor/algolia/products`
     *
     * @operationId VendorSyncAlgoliaProducts
     * @source packages/modules/algolia/src/api/vendor/algolia/products/route.ts
     */
    createProduct: (body, query, headers) => client.fetch("/vendor/algolia/products", { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/algolia/products`
     *
     * @operationId VendorGetAlgoliaProductStatus
     * @source packages/modules/algolia/src/api/vendor/algolia/products/route.ts
     */
    listProducts: (query, headers) => client.fetch("/vendor/algolia/products", { method: "GET", query, headers }),
});
//# sourceMappingURL=algolia.js.map